import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  toggle() {
    this.sidebarTarget.classList.toggle("show")
    this.overlayTarget.classList.toggle("show")
  }

  close() {
    this.sidebarTarget.classList.remove("show")
    this.overlayTarget.classList.remove("show")
  }

  // Close menu when clicking nav links (helpful for logout and other navigation)
  closeOnNavClick(event) {
    // Only close if clicking a nav link or button
    if (event.target.closest('.nav-link') || event.target.closest('button')) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.sidebarTarget.classList.contains("show")) {
      this.close()
    }
  }

  connect() {
    document.addEventListener("keydown", this.closeOnEscape.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape.bind(this))
  }
}